import React, { useState } from 'react'
import Dialog from '@mui/material/Dialog'
import PhoneIcon from '@mui/icons-material/Phone'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'
import { Divider, ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import LinkMUI from '@mui/material/Link'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import { useIsMerchant } from '../../../config/utils/RolesUtils'
import { getCommercial } from '../../../api/pntagent.api'
import { useTheme } from '@mui/material'
import profileConfig from '@/config/constants/profile/config_pontio.js'

const HeaderPhone = () => {
  const theme = useTheme()
  const { t } = useTranslation()
  const isMerchant = useIsMerchant()

  const [phonePop, setPhonePop] = useState(false)
  const technicalSupportTel = profileConfig.technicalSupportTel
  const customerServiceTel = profileConfig.customerServiceTel
  const [commercial, setCommercial] = useState(null)

  const handlePhone = () => {
    if (isMerchant) {
      getCommercial()
        .then((response) => {
          setCommercial(response.data)
        })
        .catch(() => setCommercial(null))
    }
    setPhonePop(true)
  }

  return (
    <LinkMUI>
      <MenuItem onClick={handlePhone}>
        <ListItemIcon>
          <PhoneIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText primary={t('HEADER.PHONE')} />
      </MenuItem>
      <Dialog
        onClose={() => setPhonePop(false)}
        open={phonePop}
        slotProps={{ paper: { style: { borderRadius: '0.375rem' } } }}
        style={{
          borderRadius: '0.375rem',
          boxShadow: theme.customShadows.medium,
        }}>
        <Grid container style={{ backgroundColor: theme.palette.background.primary.color }}>
          <Grid size={12}>
            <Typography
              style={{
                color: theme.palette.text.light.color,
                textDecoration: 'underline',
                paddingLeft: '2rem',
                paddingTop: '1rem',
              }}
              variant="h5">
              {t('HEADER.PHONE')}
            </Typography>
          </Grid>
          <Grid size={12} style={{ padding: '1rem 2rem' }}>
            <Typography align="justify" style={{ color: theme.palette.text.light.color }}>
              {t('HEADER.CALL.TEXT')}
            </Typography>
            <List sx={{ listStyleType: 'disc' }}>
              <ListItem>
                <Typography style={{ color: theme.palette.text.light.color }}>
                  {t('HEADER.CALL.TEL1')}{' '}
                  <b>{commercial?.tlphnumber ? commercial?.tlphnumber : technicalSupportTel} </b>
                </Typography>
              </ListItem>
              <ListItem>
                <Typography style={{ color: theme.palette.text.light.color }}>
                  {t('HEADER.CALL.TEL2')} <b>{commercial?.tlphnumber ? commercial?.tlphnumber : customerServiceTel}</b>
                </Typography>
              </ListItem>
            </List>
          </Grid>
        </Grid>
        <Divider
          style={{
            backgroundColor: theme.palette.background.primaryLight.color,
            height: '0.0625rem',
          }}
          flexItem
        />
        <Grid
          style={{
            backgroundColor: theme.palette.background.primary.color,
            display: 'flex',
            alignItems: 'center',
            gap: '3rem',
            justifyContent: 'center',
          }}>
          <LinkMUI
            style={{ color: 'white', cursor: 'pointer' }}
            href={'tel:' + commercial?.iduser?.tlphnumber ? commercial?.iduser?.tlphnumber : technicalSupportTel}>
            <Typography
              style={{
                height: '3rem',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                color: theme.palette.text.light.color,
              }}>
              <PhoneIcon style={{ marginRight: '4px' }} fontSize="medium" />
              {t('HEADER.CALL.TECH')}
            </Typography>
          </LinkMUI>
          <LinkMUI
            style={{ color: 'white', cursor: 'pointer' }}
            href={'tel:' + commercial?.iduser?.tlphnumber ? commercial?.iduser?.tlphnumber : customerServiceTel}>
            <Typography
              style={{
                height: '3rem',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                color: theme.palette.text.light.color,
              }}>
              <PhoneIcon style={{ marginRight: '4px' }} fontSize="medium" />
              {t('HEADER.CALL.CUST')}
            </Typography>
          </LinkMUI>
        </Grid>
      </Dialog>
    </LinkMUI>
  )
}

export default HeaderPhone
